/**
 * No operation function. Mainly used in default React contexts to stop it ruining code coverage.
 */
export function doNothing() {}
